<template>
  <v-chip
    variant="flat"
    :class="['question-answer-status-chip', `question-answer-status-chip--${status}`]"
    size="small"
  >
    <span class="font-weight-medium text--x-small ml-1">
      {{ $t(`common.qaStatus.${status}`) }}
    </span>
  </v-chip>
</template>

<script>
import { QA_STATUS } from '@/common/utils/qa-status'

export default {
  name: 'QuestionAnswerStatusChip',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      QA_STATUS,
    }
  },
}
</script>

<style scoped lang="scss">
.question-answer-status-chip {
  &--to_answer {
    background-color: rgb(var(--v-theme-surface-warning-bold)) !important;
    color: rgb(var(--v-theme-text-warning)) !important;
  }
  &--to_validate {
    background-color: rgb(var(--v-theme-surface-info)) !important;
    color: rgb(var(--v-theme-text-info)) !important;
  }
  &--validated {
    background-color: rgb(var(--v-theme-surface-success)) !important;
    color: rgb(var(--v-theme-text-success)) !important;
  }
}
</style>
